import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SignaturePad } from 'angular2-signaturepad';
import { Delivery } from 'src/app/models/delivery.schema';
import { DeliveryService } from 'src/app/services/delivery.service';
import { CommanUsesService } from './../../services/comman-uses.service';

@Component({
  selector: 'app-receipt',
  templateUrl: './receipt.component.html',
  styleUrls: ['./receipt.component.scss']
})
export class ReceiptComponent implements OnInit {

  recieptForm: any;
  delivery: Delivery;
  otherOption: boolean = false;
  receiverOptions: any;
  pickUpFTime: any;
  pickUpTTime: any;
  pickUpFTimeError: boolean = false;
  pickUpTTimeError: boolean = false;
  isEditable: boolean = false;
  openFrom: string;
  disabledBtn: boolean = false;
  
  @ViewChild(SignaturePad, { static: false }) signaturePad: SignaturePad;
  signaturePadOptions = {
    minWidth: 2,
    canvasWidth: 590,
    canvasHeight: 200
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { delivery: Delivery, isEditable: boolean, openFrom: string },
    private fb: FormBuilder,
    private deliveryService: DeliveryService,
    private dialogRef: MatDialogRef<ReceiptComponent>,
    private commanUsesService: CommanUsesService,
  ) { 
    this.isEditable = this.data.isEditable;
    this.delivery = this.data?.delivery;
    this.openFrom = this.data?.openFrom;
  }

  ngOnInit() {
    this.handleRecieptForm();
  }

  handleRecieptForm(){
    this.recieptForm = this.fb.group({
      receiverSurname: [''],
      receiverName: [''],
      image: [null, [this.validateImageFile]],
      deliveryProducts: this.fb.array([]) 
    })

    this.initDeliveryProducts();

    this.receiverOptions = this.delivery?.receiverType;
    if(this.delivery?.receiverType != null){
      this.otherOption = this.delivery?.receiverType.toLowerCase() != 'recipient';
      this.recieptForm.patchValue({
        receiverSurname: this.delivery?.receiverType.toLowerCase() != 'recipient' ?  this.delivery?.receiverSurname : null,
        receiverName: this.delivery?.receiverType.toLowerCase() != 'recipient' ?  this.delivery?.receiverName : null
      });
    }
  }

  get deliveryProductsArray(): FormArray {
    return this.recieptForm.get('deliveryProducts') as FormArray;
  }

  getControl(i: number, field: string) {
    return this.deliveryProductsArray.at(i).get(field);
  }

  isWarehouseService(): boolean {
    return this.delivery?.serviceType?.toLowerCase() === 'warehouseservice';
  }

  initDeliveryProducts() {
    const isWarehouse = this.isWarehouseService();

    this.deliveryProductsArray.clear();

    (this.delivery?.deliveryProducts || []).forEach(item => {
      this.deliveryProductsArray.push(this.fb.group({
        id: [item.id],

        length: [
          item.length || null,
          isWarehouse ? [Validators.required, Validators.min(1)] : []
        ],

        width: [
          item.width || null,
          isWarehouse ? [Validators.required, Validators.min(1)] : []
        ],

        height: [
          item.height || null,
          isWarehouse ? [Validators.required, Validators.min(1)] : []
        ],

        weight: [
          item.weight || null,
          isWarehouse ? [Validators.required, Validators.min(0.1)] : []
        ]
      }));
    });

    this.deliveryProductsArray.updateValueAndValidity();
  }

  onFileSelect(event) {
    const file = (event.target as HTMLInputElement).files[0];
    if (file) {
      this.recieptForm.patchValue({
        image: file
      });
      this.recieptForm.get('image').updateValueAndValidity();
    }
  }

  validateImageFile(control) {
    const file = control.value;
    if (file) {
      const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.pdf)$/i;
      if (!allowedExtensions.exec(file.name)) {
        return { invalidImage: true };
      }
    }
    return null;
  }

  get imageControl() {
    return this.recieptForm.get('image');
  }

  async onSubmit(){
    if (this.recieptForm.valid) {
      this.recieptForm.value.receiverType = this.receiverOptions ? this.receiverOptions : null;
      if(this.delivery.ddtNumber && this.delivery.serviceType.toLowerCase() === 'sales' && this.openFrom.toLowerCase() === 'activities'){
        let deliveryData = await this.deliveryService.findDeliveriesWithDDTNumber(this.delivery);
        for(let delivery of deliveryData || []){
          await this.deliveryService.saveReceiptInfo(delivery?.id, this.recieptForm.value);
        }
        this.dialogRef.close({ success: true });
      } else {
        let promise = this.deliveryService.saveReceiptInfo(this.delivery?.id, this.recieptForm.value);
        promise.then(async (res: any) => {
          if(res){
            this.dialogRef.close({ success: true });
          }
        }).catch(async (err) => {
          console.log('err', err);

          this.dialogRef.close({
            success: false,
            errorMessage: this.getBackendErrorMessage(err)
          });
        });
      }
    } 
  }

  private getBackendErrorMessage(error: any): string {
    if (error?.error?.message) {
      if (Array.isArray(error.error.message)) {
        return error.error.message.join(', ');
      }

      return error.error.message;
    }

    if (typeof error?.error === 'string') {
      return error.error;
    }

    if (error?.message) {
      return error.message;
    }

    return 'SOMETHING_WENT_WRONG';
  }

  onSelectChange(option: any){
    if(option.toLowerCase() === 'other' || option.toLowerCase() === 'concierge'){
      this.otherOption = true;
    } else {
      this.otherOption = false;
      this.recieptForm.patchValue({
        receiverSurname: '',
        receiverName: ''
      });
    }
  }

  handleDateClick(arg) {
    console.log('date click!', arg.dateStr)
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.signaturePad) {
        this.signaturePad.clear();
      } else {
        console.error('SignaturePad is STILL undefined');
      }
    }, 0);
  }

  drawComplete() {}

  clear() {
    this.signaturePad.clear();
  }

  async save() {
    try {
      if (this.signaturePad.isEmpty()) {
        this.commanUsesService.showSnackBar('Si prega di firmare prima di salvare.');
        return;
      }

      const base64 = this.signaturePad.toDataURL();
      this.disabledBtn = true;
      const result = await this.deliveryService.uploadSign(this.delivery.id, base64);
      this.delivery = result.delivery;
      this.commanUsesService.showSnackBar(result.message);
    } catch (error: any) {
      const errorMsg: string = error?.error?.message || 'SOMETHING_WENT_WRONG';
      this.commanUsesService.showSnackBar(errorMsg);
    } finally {
      this.disabledBtn = false;
    }
  }

  async deleteSignature() {
    try {
      this.disabledBtn = true;
      const result = await this.deliveryService.removeSign(this.delivery.id);
      this.delivery = result.delivery;
      this.commanUsesService.showSnackBar(result.message);
    } catch (error) {
      const errorMsg: string = error?.error?.message || 'SOMETHING_WENT_WRONG';
      this.commanUsesService.showSnackBar(errorMsg);
    } finally {
      this.disabledBtn = false;
    }
  }


}
